module.exports = __webpack_public_path__ + "media/images/projects/picto_etiquette-c42a32c74675e61f6cbfcd90e079fe13.svg";